import { gqlHandleError } from "@/services/graphqlEndPointCommonSetting/graphqlErrorHandler";
import { getGraphqlClient } from "@/services/graphqlEndPointCommonSetting/gqlClient";
export async function wrapGqlRequest(
  queryOrMutation,
  variables = {},
  operationName = "",
  authRequired = true,
) {

  const excludedOperations = ["generateCustomerToken", "createCustomerV2", "resetPassword", "requestPasswordResetEmail"];

  let passAuthHeader = excludedOperations.includes(operationName);

  const client = getGraphqlClient({ passAuthHeader: !passAuthHeader });

  let response;
  try {
    const isMutation = /^\s*mutation\b/i.test(queryOrMutation);
    const op = isMutation
      ? client.mutation(queryOrMutation, variables)
      : client.query(queryOrMutation, variables);
    response = await op.toPromise();
  } catch (error) {
    await gqlHandleError(error, variables, client.url, authRequired);
  }

  // Outside the try above: gqlHandleError always throws, so calling it from
  // here would otherwise be caught by that same try's catch and re-run on an
  // already-normalized error, losing fields like `code` (e.g. placeOrder's
  // CART_NOT_ACTIVE) that only the first pass knows how to read.
  if (response.error) {
    await gqlHandleError(response.error, variables, client.url, authRequired);
  }
  if (response.data?.[operationName]?.user_errors?.length > 0) {
    await gqlHandleError(
      { userErrors: response.data[operationName].user_errors },
      variables,
      client.url,
    );
  }
  if (response.data?.[operationName]?.errors?.length > 0) {
    await gqlHandleError(
      { userErrors: response.data[operationName].errors },
      variables,
      client.url,
    );
  }
  return operationName && response.data
    ? response.data[operationName]
    : response.data;
}
